import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { DownloadableFileListComponent } from '@app/components/downloadable-file-list/downloadable-file-list.component';
import {
  PersonSimpleWithRole,
  ProjectPublicResponse,
} from '@app/models/project.models';
import { BaseEnumItemByIdPipe } from '@app/pipes/base-enum-item-by-id.pipe';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-section-a',
  imports: [
    CommonModule,
    TranslatePipe,
    BaseEnumItemByIdPipe,
    CardComponent,
    LabeledContentComponent,
    DownloadableFileListComponent,
  ],
  templateUrl: './project-details-section-a.component.html',
  styleUrl: './project-details-section-a.component.scss',
  providers: [GetLocalizedPipe],
})
export class ProjectDetailsSectionAComponent {
  genericStore = inject(GenericStore);
  protected translationKey = 'projectDetails.sectionaA.';
  projectDetails = input.required<ProjectPublicResponse>();

  constructor(private localizedPipe: GetLocalizedPipe) {}

  protected getTitle(person: PersonSimpleWithRole): string {
    const title = this.genericStore
      .nameTitlesEntities()
      .find(
        (t) => t.code === person.titleCode || t.id === person.titleCode,
      );
    return title === undefined
      ? ''
      : this.localizedPipe.transform(title?.localized);
  }

  protected getNameTitle(person: PersonSimpleWithRole): string {
    const parts = [
      this.getTitle(person),
      person.lastName,
      person.midName,
      person.firstName,
    ].filter(Boolean);
    return parts.join(' ').trim() || ' - ';
  }

  getProjectLeaderNameTitle(): string {
    const projectLeader = this.projectDetails().personsSectionA.find(
      (person) => person.role.code === 'ProjVez'
    );
    if (projectLeader === undefined) {
      return ' - ';
    }
    return this.getNameTitle(projectLeader);
  }

  protected getPersonNameLabel(person: PersonSimpleWithRole): string {
    return this.translationKey + (
      person.role.code === 'ProjUgyvVez' ? 'poAdministrativeName' : 'poProfilerName'
    );
  }

  protected getPersonTitleLabel(person: PersonSimpleWithRole): string {
    return this.translationKey + (
      person.role.code === 'ProjUgyvVez' ? 'poAdministrativeTitle' : 'poProfilerTitle'
    );
  }
}
